module.exports = __webpack_public_path__ + "img/tsp_documents.f108a847.png";